import React, { useEffect, useMemo } from 'react';
import { Spin, Tabs } from 'antd';
import styled from 'styled-components';

import GroupsTabPane from './groups/GroupsTabPane';
import UsersTabPane from './users/UsersTabPane';
import SimpleNavigationBar from '../navigation/SimpleNavigationBar';

const StyledAuthorizationView = styled.div`
  height: calc(100% - 63px);
  overflow-y: auto;

  .authorization-view-wrapper {
    display: flex;
    flex-direction: column;
    padding: 20px;

    & > .authorization-view-header-wrapper {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;
    }
  }

  .ant-tabs-tab {
    padding: 12px 16px;
  }
`;

const AuthorizationView = ({
  fetchingGroups,
  updatingGroup,
  fetchingUsers,
  updatingUser,
  deleting,
  fetchGroups,
  fetchUsers,
  tabKey,
  setTabKey,
}) => {
  useEffect(() => {
    Promise.all([fetchGroups(), fetchUsers()]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const tabItems = useMemo(() => {
    return [
      {
        key: '1',
        label: 'Users',
        children: <UsersTabPane />,
      },
      {
        key: '2',
        label: 'Groups',
        children: <GroupsTabPane />,
      },
    ];
  }, []);

  return (
    <>
      <SimpleNavigationBar />
      <StyledAuthorizationView>
        <Spin
          spinning={fetchingGroups || updatingGroup || fetchingUsers || updatingUser || deleting}
          size="large"
        >
          <div className="authorization-view-wrapper">
            <div className="authorization-view-header-wrapper">
              <h2 style={{ margin: 0 }}>Authorization</h2>
            </div>
            <Tabs defaultActiveKey={tabKey} items={tabItems} onChange={setTabKey} />
          </div>
        </Spin>
      </StyledAuthorizationView>
    </>
  );
};

export default AuthorizationView;
